// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elder-modal{position:fixed;z-index:10;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:2rem;background-color:rgba(3,10,12,.65)}.elder-modal-enter,.elder-modal-leave-to{opacity:0}.elder-modal-enter-active,.elder-modal-leave-active{transition:opacity .3s ease}body[elder-modal-open]{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"primary": "#1d56d8",
	"secondary": "#4274e6",
	"warning": "#e9ab05",
	"success": "#0abb59",
	"error": "#e7201b",
	"light-grey": "#f7f7f7",
	"dark": "#272727",
	"grey": "#e3e3e3"
};
module.exports = exports;
